import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { FaPencilAlt as PencilIcon, FaTrash as TrashIcon } from 'react-icons/fa';

import { GridMode } from '../../shared/gridEdit/useEditableGridLogic';
import ValidationMessagesCellRenderer from '../../shared/gridEdit/validationMessagesCellRenderer.component';
import { connect } from 'react-redux';
import { showObligationModalForDelete } from './store/actions';
import { getObligationUniqueId } from './helpers';
import obligationPropTypes from './obligation.propTypes';

const obligationRowIsEdited = ({ editedRowId, obligation }) => editedRowId === getObligationUniqueId(obligation);

const ObligationsAdminColumnRenderer = props => {
  const {
    data: obligation,
    editRow,
    rowIndex,
    context,
    showDeleteObligationModal,
  } = props;

  const {
    mode,
    canModifyAllObligations,
    companyCodesSet,
    canModifyInSelectedPeriod,
    editedRowId,
  } = context;

  const showDeleteModal = useCallback(() => {
    showDeleteObligationModal({ entity: obligation, rowIndex });
  }, [showDeleteObligationModal, rowIndex, obligation]);

  const onEditClick = useCallback(() => {
    editRow(obligation);
  }, [obligation, editRow]);

  const isEditingMode = mode === GridMode.Add || mode === GridMode.Edit || mode === GridMode.EditAll;
  const isRowEdited = obligationRowIsEdited({ editedRowId, obligation });
  const canModify = canModifyInSelectedPeriod
    && (canModifyAllObligations || companyCodesSet.has(obligation.companyCode));
  const isDisabled = isEditingMode || !canModify;

  if (isEditingMode && isRowEdited) {
    return <ValidationMessagesCellRenderer {...props} />;
  }

  return (
    <div>
      <button
        className="cell-icon-button"
        title="Edit Obligation"
        onClick={onEditClick}
        disabled={isDisabled}
      >
        <PencilIcon size={16} className="cell-icon disabled-visible"/>
      </button>
      <button
        className="cell-icon-button"
        title="Remove Obligation"
        onClick={showDeleteModal}
        disabled={isDisabled}
      >
        <TrashIcon size={16} className="cell-icon disabled-visible" />
      </button>
    </div>
  );
};

ObligationsAdminColumnRenderer.propTypes = {
  data: obligationPropTypes.isRequired,
  rowIndex: PropTypes.number,
  showDeleteObligationModal: PropTypes.func.isRequired,
  editRow: PropTypes.func.isRequired,
  context: PropTypes.shape({
    mode: PropTypes.string.isRequired,
    canModifyInSelectedPeriod: PropTypes.bool.isRequired,
    canModifyAllObligations: PropTypes.bool.isRequired,
    companyCodesSet: PropTypes.instanceOf(Set).isRequired,
    editedRowId: PropTypes.string,
  }),
};

export default connect(null, {
  showDeleteObligationModal: showObligationModalForDelete,
})(ObligationsAdminColumnRenderer);
